import cookies, {VALUE_TRACK_KEY} from './cookies'
import {ValueTrack} from '../hooks/useValueTrackSaver'

const VALUE_TRACK_COOKIE_EXPIRATION_IN_DAYS = 30

export const removeValueTrackCookie = (): void => {
    cookies.remove(VALUE_TRACK_KEY)
}

export const saveValueTrackCookie = (valueTrack: ValueTrack[]) => {
    cookies.set(VALUE_TRACK_KEY, JSON.stringify(valueTrack), VALUE_TRACK_COOKIE_EXPIRATION_IN_DAYS)
}
